import ApiService from "../../services/ApiService";
import Logger from "../../services/Logger";
import UtilService from "../../services/UtilService";

const ContactService = {
    requestList: async (paginationModel, sort, setRows, setRowCount, keyword) => {
        let param = {
            page: paginationModel.page,
            pageSize: paginationModel.pageSize,
            sort: sort.map((s) => `${s.field}:${s.sort}`).join(","),
            keyword: keyword ? encodeURIComponent(keyword) : "",
        };

        const result = await ApiService.getData("/home/contact", param);
        // Logger.log(result);
        setRows(result.content);
        setRowCount(result.page?.totalElements ?? 0);

        // Logger.log(result);
    },

    requestDetail: async (selectionId, setFirstName, setLastName, setEmail, setCreated, setSubject, setContent) => {
        const result = await ApiService.getData(`/home/contact/${selectionId}`);
        // Logger.log(result);

        setFirstName(result.firstName);
        setLastName(result.lastName);
        setEmail(result.email);
        setCreated(UtilService.formatDate(result.createdAt));
        setSubject(result.subject);
        setContent(result.content);
    },

    deleteContact: async (id) => {
        const result = await ApiService.deleteData(`/home/contact/${id}`);
        // Logger.log(result);
        return result;
    },
};

export default ContactService;
